module.exports = __webpack_public_path__ + "img/f13.8bbcc09b.jpg";